import React from 'react';
import { useIntl } from 'react-intl';
import { ErrorPage } from '../components/ErrorPage';
import { ReactComponent as PageNotFoundIcon } from 'assets/icons/undraw_page_not_found.svg';
import { Helmet } from 'react-helmet-async';
import { tenantInfoState } from '../atoms';
import { useRecoilValue } from 'recoil';

export const NotFoundErrorPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const tenantInfo = useRecoilValue(tenantInfoState);

  return (
    <>
      <Helmet>
        <title>{formatMessage({ id: 'ErrorPage.NotFound.Title', defaultMessage: 'Oops ... it looks like you got lost' })} - {tenantInfo.name}</title>
        <meta name="description" content={formatMessage({ id: 'ErrorPage.NotFound.Message', defaultMessage: 'The page you are looking for does not exist' })} />
      </Helmet>
      <ErrorPage
        title={formatMessage({
          id: 'ErrorPage.NotFound.Title',
          defaultMessage: 'Oops ... it looks like you got lost',
        })}
        message={formatMessage({
          id: 'ErrorPage.NotFound.Message',
          defaultMessage: 'The page you are looking for does not exist',
        })}
        svgImage={<PageNotFoundIcon style={{ maxWidth: '500px' }} />}
      />
    </>
  );
};
